module.exports = __webpack_public_path__ + "img/dian.59ce5ec6.png";